import { request } from '../client';
import ApiError from '../ApiError';
import { PLACES_API_BASE_URL } from '../../config/api';

// Backend proxy for Google address lookup (/api/places/*). The Google key stays
// server-side. These routes are public and answer only about addresses, so no
// Authorization header and no delivery geography are sent with them.
const placesRequest = (path, params) => {
  if (!PLACES_API_BASE_URL) {
    return Promise.reject(new ApiError({ message: 'Address lookup is not available.', code: 'PLACES_UNAVAILABLE' }));
  }
  return request(path, { params, auth: false, deliveryGeography: null, baseUrl: PLACES_API_BASE_URL });
};

// data: [{ placeId, description }] — India only; [] for no match.
export const autocompletePlaces = (input) => placesRequest('/autocomplete', { input });

// data: { street, area, city, state, pincode, lat, lng } | null
export const getPlaceDetails = (placeId) => placesRequest('/details', { placeId });

// data: { lat, lng, locationType, types } | null
export const geocodeAddress = (address) => placesRequest('/geocode', { address });

// data: { line1, city, state, pincode, landmark, formattedAddress } | null
export const reverseGeocode = ({ lat, lng }) => placesRequest('/reverse', { lat, lng });
